import React from 'react';

import { GroupedNotification } from 'utilities/functions';

import { twMerge } from 'tailwind-merge';
import { NotificationItem } from './NotificationItem';
import moment from 'moment';
import { useIsMobile } from '../../../../../hooks/useIsMobile';
import { MobileNotificationItem } from './MobileNotificationItem';

interface INotificationGroup extends GroupedNotification {
  refreshNotification: () => void;
}

export function NotificationGroup({
  label,
  items,
  onCloseModal,
  refreshNotification,
}: INotificationGroup) {
  const isAllReadInGroup = items.every((item) => item.isRead);
  const isMobile = useIsMobile();
  return (
    <div
      className={twMerge('flex flex-col', isAllReadInGroup && 'bg-neutral-100')}
    >
      <div className="px-30 pt-5 text-med-gray-3 text-sm font-semibold">
        {label}
      </div>

      {items
        .sort((a, b) => moment(b.originalDate).diff(moment(a.originalDate)))
        .map((data) => {
          return isMobile ? (
            <MobileNotificationItem
              key={data.id}
              {...data}
              onClick={onCloseModal}
              refreshNotification={refreshNotification}
            />
          ) : (
            <NotificationItem
              key={data.id}
              {...data}
              onClick={onCloseModal}
              refreshNotification={refreshNotification}
            />
          );
        })}
    </div>
  );
}
